import type { Signer } from '@polkadot/types/types';

import { stringToHex } from '@polkadot/util';

export const signMessage = async (address: string, message: string) => {
  const { web3FromAddress } = await import('@polkadot/extension-dapp');

  /// finds an injector for an address
  const injector = await web3FromAddress(address as string);

  // this injector object has a signer and a signRaw method
  // to be able to sign raw bytes
  const signRaw = injector?.signer?.signRaw;

  let msgSignatrue = '';
  if (signRaw) {
    // after making sure that signRaw is defined
    // we can use it to sign our message
    const { signature } = await signRaw({
      address: address as string,
      data: stringToHex(message),
      type: 'bytes'
    });
    msgSignatrue = signature;
  }
  return msgSignatrue;
};

export async function signMessageWithSigner(signer: Signer, address: string, message: string) {
  // this injector object has a signer and a signRaw method
  // to be able to sign raw bytes
  const signRaw = signer.signRaw;

  let msgSignatrue = '';
  if (signRaw) {
    // after making sure that signRaw is defined
    // we can use it to sign our message
    const { signature } = await signRaw({
      address: address as string,
      data: stringToHex(message),
      type: 'bytes'
    });
    msgSignatrue = signature;
  }
  return msgSignatrue;
}
